export default {
  data () {
    return {
      password: '',
      confirmPassword: ''
    }
  },
  computed: {
    checkPasswords () {
      return this.password === this.confirmPassword
    }
  },
  methods: {
    onPasswordChange ({ name, value }) {
      const match = /\[(\w*)\]/.exec(name)

      if (!match || !match[1]) {
        return false
      }

      if (match[1] === 'password') {
        this.password = value
      }

      if (match[1] === 'confirm_password') {
        this.confirmPassword = value
      }

      if (match[1] === 'password_confirmation') {
        this.confirmPassword = value
      }
    }
  }
}
